/**
 * Get the computed value of a CSS variable.
 * @param {string} varName - The name of the CSS variable (e.g., '--breakpoint-sm').
 * @param {HTMLElement} [element] - The element to check. Defaults to document.documentElement (:root).
 * @returns {string} The value of the CSS variable.
 */
export const getCssVariable = (
  varName: string,
  element: HTMLElement = document.documentElement,
) => {
  // Use getComputedStyle to get the *applied* styles
  const computedStyles = window.getComputedStyle(element);
  // getPropertyValue retrieves the specific variable value
  const value = computedStyles.getPropertyValue(varName).trim();

  if (!value) {
    throw new Error(`CSS variable ${varName} not found or is empty.`);
  }

  return value;
};
